import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CalendarEvent, CalendarView, DAYS_OF_WEEK } from "angular-calendar";
import { endOfWeek, format, startOfWeek } from "date-fns";
import { NgxSpinnerService } from "ngx-spinner";
import { Studio } from "src/app/models/studio-model";
import { User } from "src/app/models/user-model";
import { ReservationService } from "src/app/services/reservation/reservation.service";
import { StudioService } from "src/app/services/studio/studio.service";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

@Component({
  selector: 'app-mon-planning',
  templateUrl: './mon-planning.component.html',
  styleUrls: ['./mon-planning.component.scss']
})
export class MonPlanningComponent implements OnInit, AfterViewInit {
  view: CalendarView = CalendarView.Week;
  studios: any;
  viewDate: Date = new Date();
  events: CalendarEvent[] = []; // Initially an empty array
  currentRange: { start: string; end: string } | null = null;
  params: any;
  currentStudio: Studio | null = null;
  currentUser: User | null = null;
  currentStudioId: any | null = null;
  startDate: any | null = "--- ---";
  endDate: any | null = "--- ---";
  loading: boolean = true; // Set loading to true initially
  submitted = false;
  selectedStartDate: string = "--- ---"; // To hold the formatted start date
  selectedEndDate: string = "--- ---"; // To hold the formatted end date

  messageListener: any;
  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private studioService: StudioService,
    private reservationService: ReservationService
  ) { }


  ngOnInit(): void {
    this.spinner.show();

    // Add the message listener when the component initializes
    this.messageListener = (event: MessageEvent) => {
      if (event.origin !== environment.webflow_url) {
        return;
      }

      const { scrollToElementId } = event.data;

      if (scrollToElementId) {
        const element = document.getElementById(scrollToElementId);
        if (element) {
          Webflow.setIFrameHeight(false, 100);
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    };

    // Attach the event listener to the window
    window.addEventListener("message", this.messageListener);

    this.activatedRoute.queryParams.subscribe((params) => {
      this.params = params;
      if (params.start_date && params.end_date) {
        this.startDate = params.start_date;
        this.endDate = params.end_date;
      }
      //get params

      this.studioService
        .get()
        .subscribe((studios) => {
          // this.studios = studios.data.map((studio) => Studio.attributeToJson(studio));

          this.studios = [
            { id: null, name: 'Sélectionner un studio' }, // Default item
            ...studios.data.map((studio) => Studio.attributeToJson(studio)),
          ];
          this.studios.sort((a, b) => b.is_default - a.is_default);

          if (this.studios.length > 0) {
            this.currentStudio = this.studios[0];
          }
          if (this.params.studio) {
            if (
              this.studios.some(
                (studio: any) => studio.slug == this.params.studio
              )
            ) {
              this.currentStudio = this.studios.find(
                (studio: any) => studio.slug == this.params.studio
              );
            } else {
              Swal.fire({
                title: "Attention",
                text: `Le studio avec le slug ${this.params.studio} n'existe pas!`,
                icon: "error",
                position: "top",
              });
            }
          }
          this.currentStudioId = this.currentStudio.id;
        })
        .add(() => {
          setTimeout(() => {
            Webflow.setIFrameHeight(true, 100);
            this.spinner.hide();
            this.loading = false;
          }, 500);
        });
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener("message", this.messageListener);
  }

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  switchToStudio(studioId: string): void {
    this.loading = true; // Set loading to true when switching studio
    const id = parseInt(studioId, 10);
    this.currentStudio =
      this.studios.find((studio) => studio.id === id) || null;
    if (this.currentStudio) {
      this.currentStudioId = this.currentStudio.id;
    }
    // send the formatted start and end dates
    if (this.currentStudioId && this.currentStudioId != null && this.currentStudioId != 'null') {
      this.fillCalendarWithSelectedRange(this.getFormattedWeekDates());
    }
    // Simulate an image loading delay (optional, for demonstration)
    setTimeout(() => {
      this.loading = false; // Reset loading after a delay (remove this in real use case)
    }, 1500);
  }


  getFormattedWeekDates() {
    const startOfWeekDate = startOfWeek(this.viewDate, {
      weekStartsOn: this.weekStartsOn as 0 | 1 | 2 | 3 | 4 | 5 | 6,
    });
    const endOfWeekDate = endOfWeek(this.viewDate, {
      weekStartsOn: this.weekStartsOn as 0 | 1 | 2 | 3 | 4 | 5 | 6,
    });

    const formattedStart = format(startOfWeekDate, "yyyy-MM-dd");
    const formattedEnd = format(endOfWeekDate, "yyyy-MM-dd");

    return { start: formattedStart, end: formattedEnd };
  }

  // Handle the selected time range from CalendarHeaderComponent
  fillCalendarWithSelectedRange(range: { start: string; end: string }): void {
    this.currentRange = range; // Store the range for later use
    if (range && this.currentStudioId) {
      this.spinner.show();
      this.reservationService
        .fetchEvent(
          this.currentRange.start,
          this.currentRange.end,
          this.currentStudioId
        )
        .subscribe(
          (events: CalendarEvent[]) => {
            this.events = events; // Assign the fetched events to the local events array
          },
          (error) => {
            console.error("Error fetching events:", error);
          }
        )
        .add(() => {
          this.spinner.hide();
        });
    }
  }
}
